import { teamSummaryViewComp } from './components/wsSummary';


window.teamSummaryViewComp = teamSummaryViewComp;
